<template>
  <v-container>
    <div>
      <v-data-table
       v-model="selected"
       :headers="headers"
       :items="employees"
       :page.sync="page"
       :items-per-page="5"
       :single-select="true"
       item-key="id"
       :search="search"
       show-select
       class="text-left elevation-1 pa-3 font-weight-regular blue--text text--darken-4"
       @page-count="pageCount = $event">

       <template v-slot:[`item.name`]="{ item }">
           <v-list-item>
               <v-list-item-avatar>
                   <v-img
                       v-if="item.avatar"
                       src="https://cdn.vuetifyjs.com/images/john.png">
                   </v-img>
                   <v-icon
                       v-else
                       x-large>
                     account_circle
                   </v-icon>
               </v-list-item-avatar>
               <v-list-item-content>
                   <v-list-item-title>{{item.name}}</v-list-item-title>
                   <v-list-item-subtitle>{{item.cargo}}</v-list-item-subtitle>
               </v-list-item-content>
           </v-list-item>
       </template>

       <template v-slot:[`item.status`]="{ item }">
        <v-chip
         :class="getTextColor(item.status)"
         label
         :color="getColor(item.status)"
         dark>
         {{ item.status && item.status === 1 ? "Ativo": item.status === 0 ? "Desativado" : "Pendente" }}
        </v-chip>
       </template>

       <template v-slot:[`item.created_at`]="{ item }">
           <span>{{formatDate(item.created_at)}}</span>
       </template>

       <template v-slot:top>
        <v-toolbar flat color="white">

            <v-toolbar-title>
              Usuários
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn
             color="primary"
             dark
             class="mb-2"
             @click="$router.push('/newuser')">
             <v-icon left>
               add
             </v-icon>
             Adicionar Novo
            </v-btn>

<!--            <v-btn
             depressed
             class="mb-2 ml-3 blue&#45;&#45;text"
             @click="$router.push('/usersrules')" >
              <v-icon left>
               people
              </v-icon>
              Regras de Usuários
            </v-btn>-->
        </v-toolbar>
        <v-spacer>
        </v-spacer>
        <v-text-field
         class="mx-4 mb-5"
         v-model="search"
         append-icon="mdi-magnify"
         label="Buscar"
         single-line
         hide-details>
        </v-text-field>
       </template>

       <template
              v-slot:[`item.actions`]="{ item }">
              <v-icon
                  class="mr-2"
                  @click="editItem(item)">mdi-pencil
              </v-icon>
              <v-tooltip
                  v-if="item.status === 1" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      color="error"
                      @click="disableItem(item)">person_off
                    </v-icon>
                  </template>
                  <span>Desabilitar usuário</span>
              </v-tooltip>
              <v-tooltip
                  v-else
                  top>
                  <template
                      v-slot:activator="{ on, attrs }">
                    <v-icon
                      color="success"
                      v-bind="attrs"
                      v-on="on"
                      @click="enableItem(item)">
                      how_to_reg
                    </v-icon>
                  </template>
                  <span>Habilitar usuário</span>
              </v-tooltip>
          </template>

      </v-data-table>

      <div class="text-center pt-2">
        <v-pagination
            v-model="page"
            :length="pageCount">
        </v-pagination>
      </div>
    </div>
  </v-container>
</template>
<script>
    import moment from "moment"
    export default {
        name:"UsersTable",
        data: () => ({
            search:'',
            selected: [],
            page: 1,
            pageCount: 0,
            dialog: false,
            headers: [
                {text: 'Nome', align: 'start', sortable: false, value: 'name',},
                { text: 'Status', value: 'status' },
                { text: 'Data Registro', value: 'created_at' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                name: '',
                cargo: '',
                status: '',
                date: '',
            },
            defaultItem: {
                name: '',
                cargo: '',
                status: '',
                date: '',
            },
        }),

        created (){
            this.initialize();
        },

        computed: {

            formTitle () {
                return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
            },

            employees(){
                return this.$store.getters.employees;
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },

        methods: {

            async initialize (){

               await this.$store.dispatch('loadEmployees');

            },

            formatDate(date){
                return moment(date,'YYYY-MM-DD').format('DD/MM/YYYY')
            },

            getColor (status) {

                if (status === 1) return 'green lighten-4'
                else if (status === 0) return 'red lighten-4'
                else return 'amber lighten-4'
            },

            getTextColor (status) {

                if (status === 1) return 'green--text'
                else if (status === 0) return 'red--text'
                else return 'orange--text'
            },

            editItem (item) {
                var index = this.employees.indexOf(item)
                this.$router.push(`/changeuser/${index}`)
            },

          async disableItem (item) {
            console.log('Verificar se API foi atualizado',item)
            item.status = 0;
            let novo = {
                status: item.status,
                id: item.id
            };
            let res = await this.$store.dispatch('editEmployee',novo);

          },

          async enableItem (item) {
            console.log('Verificar se API foi atualizado',item)
            item.status = 1;
            let novo = {
                status: item.status,
                id: item.id
            }
            let res = await this.$store.dispatch('editEmployee',novo);
          },

            async deleteItem (item) {

                if (confirm('Are you sure you want to delete this item?')){
                    let deleted = await this.$store.dispatch("removeBase", item.id)
                        .then( response=> {
                            return response.status ? true: false;
                        });
                    if (deleted){
                    this.initialize();
                    }
                }
            },

            close () {

                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },

            async save () {

                /*if (this.editedIndex > -1) {
                    Object.assign(this.desserts[this.editedIndex], this.editedItem)
                } else {
                    this.desserts.push(this.editedItem)
                }*/
                this.close()
            },
        },
    }
</script>

<style>
</style>
